export default __webpack_public_path__ + "static/logo-e74af8c19e079bb3b78057e55a2093df.svg";